import { Chapter, Reveal } from "./Reveal";

const CHAPTERS = [
    {
        n: "01",
        title: "Personalised, not packaged",
        body: "Rather than following a one-size-fits-all program, our sessions focus on the student's current coursework, upcoming assessments and areas of difficulty — with additional practice and extension where it counts.",
    },
    {
        n: "02",
        title: "We've just lived the HSC",
        body: "We understand what it is like to be a student because we have recently been through the same school system ourselves. As Knox Grammar graduates with ATARs of 97 and 95, we know what senior school demands — and what actually works.",
    },
    {
        n: "03",
        title: "High-achieving university tutors",
        body: "As UNSW Engineering students, we bring strong academic knowledge alongside real experience tutoring students across a wide range of year levels and subjects — from Year 4 maths to Year 12 chemistry.",
    },
    {
        n: "04",
        title: "Genuine value for families",
        body: "By operating independently rather than as a large tutoring company, we offer personalised tutoring at roughly $10–$30 less per hour than many bigger providers — without compromising on quality.",
    },
];

export const Manifesto = () => (
    <section id="about" data-testid="about-section" className="py-28 md:py-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Chapter
                index="Ch. 01–04"
                eyebrow="What we're about · Why us"
                title={
                    <>
                        Tutoring built around
                        <br />
                        <em className="text-navy">the individual student.</em>
                    </>
                }
                testid="about-heading"
            />
            <div className="grid md:grid-cols-2 gap-x-16">
                {CHAPTERS.map((c, i) => (
                    <Reveal key={c.n} delay={i * 0.08}>
                        <div
                            data-testid={`manifesto-chapter-${c.n}`}
                            className="border-t hairline py-10 group"
                        >
                            <div className="flex items-baseline gap-6">
                                <span className="font-serif italic text-3xl text-oxblood/70 group-hover:text-oxblood transition-colors duration-500">
                                    {c.n}
                                </span>
                                <div>
                                    <h3 className="font-serif text-2xl md:text-[1.7rem] text-ink mb-3">
                                        {c.title}
                                    </h3>
                                    <p className="text-slate2 leading-relaxed text-sm md:text-base max-w-lg">
                                        {c.body}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.1}>
                <p className="mt-8 max-w-3xl text-slate2 leading-relaxed text-sm md:text-base border-t hairline pt-10">
                    Our goal is to help students understand their subjects, build confidence
                    and develop effective study and exam techniques in a supportive and
                    approachable environment — combining the knowledge of high-achieving
                    university students with a flexible approach that stays closely connected
                    to what students are actually doing at school.
                </p>
            </Reveal>
        </div>
    </section>
);
